import { actionTypes } from '../actions/brokers'

const initial = {
  list: []
}

export default (state = initial, action) => {
  switch (action.type) {

    case actionTypes.RECEIVE_BROKERS:
      return {
        ...state,
        list: action.data && action.data.data.length ? action.data.data : [],
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/brokers.js